import React, { useEffect, useState } from 'react';
import { observer } from 'mobx-react-lite';
import chatStore from './stores/chatStore';
import { ThemeProvider } from './theme/ThemeContext';
import ChatShell from './layout/ChatShell';
import MessageList from './chat/MessageList';
import Composer from './composer/Composer';
import ChatContextPanel from './chat/ChatContextPanel';

const BananasGPTInner = observer(({ provider = 'openrouter' }) => {
    const [ready, setReady] = useState(false);
    const [bootError, setBootError] = useState(null);

    useEffect(() => {
        let cancelled = false;
        setReady(false);
        setBootError(null);
        chatStore.setProvider(provider);
        (async () => {
            try {
                await chatStore.bootstrap();
            } catch (e) {
                if (!cancelled) {
                    setBootError(e.gptError?.message || e.message || 'Ошибка загрузки');
                }
            } finally {
                if (!cancelled) setReady(true);
            }
        })();
        return () => {
            cancelled = true;
        };
    }, [provider]);

    const onPreferenceChange = (theme) => {
        chatStore.saveSettings({ theme });
    };

    return (
        <ThemeProvider preference={chatStore.settings.theme || 'system'} onPreferenceChange={onPreferenceChange}>
            <ChatShell>
                {!ready ? (
                    <div className="flex flex-1 items-center justify-center text-sm opacity-60">Загрузка…</div>
                ) : (
                    <>
                        {bootError && (
                            <div className="mx-4 mt-3 rounded-lg bg-amber-500/15 px-3 py-2 text-xs">
                                {bootError}. Проверьте API-ключ {chatStore.providerLabel} в профиле.
                            </div>
                        )}
                        <MessageList />
                        <Composer />
                        <ChatContextPanel />
                    </>
                )}
            </ChatShell>
        </ThemeProvider>
    );
});

const BananasGPTApp = ({ provider = 'openrouter' }) => <BananasGPTInner provider={provider} />;

export default BananasGPTApp;
